import { useSelectedLocation } from "components";
import { useTypedQuery } from "hooks";
import { CommunicationTemplatesQueryKeys } from "modules/CommunicationTemplates/queryKeys";
import { ApiInstance } from "utils/Api";

export const useCommunicationSettingsQuery = () => {
  const { selectedLocation } = useSelectedLocation();

  return useTypedQuery({
    queryKey: CommunicationTemplatesQueryKeys.getCommunicationSettings,
    queryFn: async () =>
      (
        await ApiInstance.post(
          CommunicationTemplatesQueryKeys.getCommunicationSettings.endpoint,
          { dealer_location_id: selectedLocation?.id },
          CommunicationTemplatesQueryKeys.getCommunicationSettings.baseUrl
        )
      ).data.settings,
    enabled: !!selectedLocation
  });
};
